import { render, staticRenderFns } from "./facetanner-filter.form.vue?vue&type=template&id=652f5a9c&"
import script from "./facetanner-filter.form.vue?vue&type=script&lang=ts&"
export * from "./facetanner-filter.form.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports